import React, { useState } from 'react'
import "./OrderCard.css";
import { faAngleRight, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import OrderTrackModal from '../common_modal/order_track_modal/OrderTrackModal';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const OrderCard = ({ order, ...props }) => {
      const dispatch = useDispatch();

    const [showCouponModal, setShowCouponModal] = useState(false)

    const navigate = useNavigate()

    return (
        <section className='OrderCard'>
            <div className='card_main_holder'>
                <div className='card_holder' >
                    <div className='right_side_part' >

                        <div className='order_details_div' >

                            <div className='first_div' onClick={() => { navigate(props?.navigate) }}>
                                <p className='order_id'>{props?.orderId}</p>
                                <div className='date_holder'>
                                    <p>{props?.date}</p>
                                </div>
                            </div>


                            <div className='order_id_div'>
                                <div className='left_detail_holder'>
                                    <p className='item'>{props?.items || 1}</p>
                                </div>
                                {props?.showtracking && props.trackingText  && (
                                    <div className='track_order_status' onClick={() => { setShowCouponModal(true) }}>
                                        Track Order
                                    </div>
                                )}

                            </div>

                            <div className='footer_text'>
                                <div className='delivery_text'>
                                    <p className='amount_text'> ₹ {props?.kwd}</p>
                                    <p style={{ color: props?.footer_text_color }} className='status_text'>{props?.footer_text}</p>
                                </div>

                                {!props?.showViewDetails && (
                                    <p className='view_details_text' onClick={() => { navigate(props?.navigate) }}>
                                        View Details
                                    </p>
                                )}


                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <OrderTrackModal
               type={props?.type}
                order={order}
                show={showCouponModal}
                onHide={() => { setShowCouponModal(false) }}
            />

        </section >
    )
}

export default OrderCard
